module.exports = __webpack_public_path__ + "static/media/dollar-sign.9c65004d.svg";